import { api } from ".";

export enum CustomerType {
  Carrier = 1, 
  Shipper = 2,
  System = 3,
}

export interface Customer {
    Id: number;
    Name: string;
    Description?: string;
    IsActive: boolean;
    UsersCount?: number;
    AppRegistrationsCount?: number;
    CustomerNumber?: number;
    ApplicationCount?: number;
    DatabaseIdentifier?: string;
    CustomerTypeId: number;
    CustomerType: string;
    Environment?: string;
    EntityId?: number;
}

export interface CustomerDbConnectivity {
  MaskedConnectionString: string;
  IsHealthy: boolean;
  Message: string;
}

export interface ApplicationCustomerUsers {
  AppId: number;
  CustomerId: number
  UserIds: number[];
}

export interface CustomerModel {
  Name: string;
  Description: string;
  CustomerNumber?: number;
  DatabaseIdentifier?: string;
  CustomerTypeId: number;
  Environment?: string;
}

export interface CustomerSyncModel {
  EntityId?: number;
  ExternalId: number;
  DatabaseName: string;
  EntityName: string;
  BusinessLineId: number;
  EntityNumber: number;
  EntityDatabaseLetter: string;
}

const customerUrlV1 = "/v1/Customers";
const appCustomersUrlV1 = "/v1/ApplicationCustomers";
const appCustomerUsersUrlV1 = "/v1/ApplicationCustomerUsers";

export type CustomerStatusFilter = "active" | "inactive";

export const getCustomers = async (
  isActive: boolean = true,
  customerTypeIds?: number[]
) => {
  const params: any = { isActive };

  if (customerTypeIds && customerTypeIds.length > 0) {
    params.customerTypeIds = customerTypeIds;
  }

  const response = await api.get<Customer[]>(customerUrlV1, { params });
  return response?.data;
};

export const getCustomersByApplicationId = async (appId: number) => {
  const response = await api.get<Customer[]>(`${appCustomersUrlV1}/${appId}/customers`);
  return response?.data;
};

export const getCustomer = async (customerId: number) => {
  const response = await api.get<Customer>(`${customerUrlV1}/${customerId}`);
  return response?.data;
};

export const getAllActiveCustomers = async () => {
  const response = await api.get<Customer[]>(customerUrlV1);
  return response?.data;
};

export const getCarrierCustomerConnectivity = async (customerNumber: number, databaseIdentifier: string) => {
  const response = await api.get<CustomerDbConnectivity>(`${customerUrlV1}/carrier/connectivity/${customerNumber}/${databaseIdentifier}`);
  return response?.data;
};

export const getShipperCustomerConnectivity = async (databaseIdentifier: string, environment: string) => {
  const response = await api.get<CustomerDbConnectivity>(`${customerUrlV1}/shipper/connectivity/${databaseIdentifier}/${environment}`);
  return response?.data;
};

export const addCustomer = async (customerModel: CustomerModel) => {
  const response = await api.post(customerUrlV1, customerModel);
  return response?.data;
}

export const updateCustomer = async (customerId: number, customer: CustomerModel) => {
  const response = await api.put(`${customerUrlV1}/${customerId}`, customer);
  return response?.status === 204;
}

export const deleteCustomer = async (customerId: number) => {
  const response = await api.delete(`${customerUrlV1}/${customerId}`);
  return response?.status === 204;
}

export const reactivateCustomer = async (customerId: number) => {
  const response = await api.post(`${customerUrlV1}/${customerId}/reactivate`, {});
  return response?.status === 204;
}

export const syncCustomer = async (customerSyncModel: CustomerSyncModel) => {
  const response = await api.post(`${customerUrlV1}/sync`, customerSyncModel);
  return response?.data;
}

export const addApplicationCustomerUsers = async (model: ApplicationCustomerUsers) => {
  const response = await api.post(`${appCustomerUsersUrlV1}/AddAccess`, model);
  return response?.data;
}

export const removeApplicationCustomerUsers = async (model: ApplicationCustomerUsers) => {
  const response = await api.post(`${appCustomerUsersUrlV1}/RemoveAccess`, model);
  return response?.data;
}